import type { ReactNode } from 'react';

export interface TraceSpan {
  name: ReactNode;
  /** Bar start as a percentage of the timeline width (0–100). */
  left: number;
  /** Bar width as a percentage of the timeline width (0–100). */
  width: number;
  color: string;
}

/** Shared placeholder trace — one source of truth for every mockup that shows it. */
export const DEMO_TRACE_SPANS: TraceSpan[] = [
  { name: 'LLM thought', left: 0, width: 48, color: 'var(--span-llm)' },
  { name: <code style={{ fontFamily: 'var(--font-mono)', fontSize: '11.5px' }}>lookup_account</code>, left: 48, width: 16, color: 'var(--span-tool)' },
  { name: 'retriever → 2 chunks', left: 64, width: 30, color: 'var(--span-rag)' },
];

export const DEMO_TRACE_TIMINGS = ['LLM 380ms', 'lookup 120ms', 'retriever 240ms'];
